import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import useAccessControl from "@/features/access-control/useAccessControl";
import { useGenerateFakeOrders } from "../hooks/useGenerateFakeOrders";

const DEMO_ORGANIZATION_ID = "fnPwZtBiX7JEjcox2AON";

const FakeOrdersButton = () => {
    const { organizationId } = useParams();
    const { getActiveUserRole } = useAccessControl();
    const { generateFakeOrders } = useGenerateFakeOrders(organizationId);

    const isDemoOrg = organizationId === DEMO_ORGANIZATION_ID;
    const isSuperAdmin = getActiveUserRole() === "super-admin";

    if (!isSuperAdmin || !isDemoOrg) return null;

    return (
        <Button onClick={generateFakeOrders}>
            Generar Ordenes de Prueba
        </Button>
    );
};

export default FakeOrdersButton;
